import 'css-chunksrc/client/scenes/planzoneVirtualResourceAddition/styles.scss';export default {
  "label": "_label_hdmhl_1",
  "row": "_row_hdmhl_7",
  "forms": "_forms_hdmhl_19",
  "group": "_group_hdmhl_30",
  "text": "_text_hdmhl_34",
  "name": "_name_hdmhl_39",
  "main": "_main_hdmhl_45",
  "buttons": "_buttons_hdmhl_52",
  "button": "_button_hdmhl_52",
  "formsOverflow": "_formsOverflow_hdmhl_66",
  "addResourceButton": "_addResourceButton_hdmhl_70"
};